<mat-accordion [multi]="withMultiple">
    <ng-container *ngFor="let child of children">
        <ng-template #children></ng-template>
    </ng-container>
</mat-accordion>